import 'layui/dist/css/layui.css';
import 'layui';

import '../css/style.css';

const oMsg = layui.layer.msg;
layui.layer.msg = (msg, options) => {
    options = options ?? {};
    if (!options.offset) {
        options.offset = `6rem`
        options.anim = options.anim ?? 'slideDown'
    }
    return oMsg(msg, options);
};

window.parseUrlParams = (url) => {
    const paramStr = url.split("?")[1] || ""; // 提取 "page=123"
    return Object.fromEntries(new URLSearchParams(paramStr))
}

window.calculateCenterPosition = (width, height) => {
    // 获取浏览器视口的实际可用区域（兼容各浏览器）
    const browserWidth = window.innerWidth || document.documentElement.clientWidth || screen.width;
    const browserHeight = window.innerHeight || document.documentElement.clientHeight || screen.height;

    // 计算居中坐标（考虑浏览器滚动偏移）
    const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    const left = scrollLeft + (browserWidth - width) / 2;
    const top = scrollTop + (browserHeight - height) / 2;

    return { left, top };
}
/**
 * message -消息发送
 * @param msg
 * @param icon 0:感叹,1成功,2错误,3疑问,4锁,5不开心,6开心
 * @param anim 0 平滑放大。默认 anim: 1 从上掉落 anim: 2 从最底部往上滑入 anim: 3 从左滑入 anim: 4 从左翻滚 anim: 5 渐显 anim: 6 抖动
 * @param anim 'slideDown' 从上边缘往下'slideLeft' 从右边缘往左v'slideUp' 从下边缘往上 'slideRight' 从左边缘往右
 */
window.message = (msg, icon = 0, anim = 1) => {
    if (!icon || icon === 2 || icon === 5) anim = 6;
    return layui.layer.msg(msg, {offset: `6rem`, icon: icon, anim: anim});
};

layui.config({
    base: "/assets/js/lay-mod/",
    BASE_API: "/api/",
    version: '2.0',
}).extend({
    common:  'common',
    captcha:  'captcha',
    users:     'users',
}).use([],()=>{
    const {layer, util, $, cache} = layui;
    const $body = $('#lanj838');
    // let messageHandler, messageHandlerInterval = null;
    window.isMobile = () => {
        if (!navigator || !navigator.userAgent) return message(`获取设备信息失败，请重试`, 2)
        const ua = navigator.userAgent.toLowerCase();
        // 匹配：iOS(手机/平板)、Android(手机/平板)、所有移动设备
        return /iphone|ipad|ipod|android|mobile|phone|ios|tablet/.test(ua) || navigator.maxTouchPoints > 0;
    }
    /**
     * 删除指定名称的 Cookie
     * @param {string} name - Cookie 名称
     * @param {string} [path='/'] - Cookie 路径（需与创建时一致）
     * @param {string} [domain] - Cookie 域名（需与创建时一致，如 '.example.com'）
     */
    window.removeCookie = (name, path = '/', domain)  => {
        // 1. 拼接 Cookie 片段（避免换行，用数组拼接）
        const cookieSegments = [
            `${encodeURIComponent(name)}=`, // 值置空
            'expires=Thu, 01 Jan 1970 00:00:00 GMT', // 强制过期
            'max-age=-1', // 现代浏览器过期指令
            `path=${path}` // 路径匹配
        ];

        // 2. 仅当传入 domain 时追加（这里需要传 localhost）
        if (domain) {
            cookieSegments.push(`domain=${domain}`);
        }

        // 3. 非 HTTPS 环境不追加 Secure（localhost 一般是 HTTP）
        if (location.protocol === 'https:') {
            cookieSegments.push('Secure');
        }

        // 4. 拼接成合法的 Cookie 字符串（分号+空格分隔）
        document.cookie = cookieSegments.join('; ');
    }

    $.ajaxSetup({
        timeout: 5000,
        error:  (xhr, status, error) => {
            // 1. 兜底基础参数，避免访问空属性报错
            const statusCode = xhr.status || 0;
            let errorMsg = '';
            if (statusCode === 0 && status === 'error') {
                return message(`跨域请求失败，请检查接口配置或网络`, 2);
            }
            // 2. 区分不同错误类型
            switch (status) {
                case 'timeout':
                    errorMsg = '请求超时，请稍后重试';
                    break;
                case 'abort':
                    errorMsg = '请求已被取消';
                    break;
                case 'parsererror':
                    errorMsg = '数据解析失败，请检查接口返回格式';
                    break;
                default:
                    // 3. 优先取业务错误信息，降级到响应文本，最后用原生error
                    errorMsg = xhr.responseJSON?.msg
                        || xhr.responseText
                        || error
                        || '未知错误';
                    break;
            }
            // 4. 统一提示（假设message是自定义提示函数，第二个参数2代表错误类型）
            message(`[${statusCode}] ${errorMsg}`, 2);
        },
    })
    //主题切换
    $('.lanj8383-theme-mode').on("click", function () {
        let f = (e) => { e ? (document.documentElement.classList.add("dark"),localStorage.setItem("theme-mode", '1')) : (document.documentElement.classList.remove("dark"), localStorage.removeItem("theme-mode"))}
        let theme = !$('html').hasClass("dark") || false;
        if (f(theme), theme) {
            if (layui.device().ie) return layer.msg("IE \u4e0d\u652f\u6301\u4e3b\u9898\u6a21\u5f0f\u5207\u6362<br>\u8bf7\u5728 Chrome \u7b49\u73b0\u4ee3\u6d4f\u89c8\u5668\u4e2d\u4f7f\u7528");
            this.INDEX = layer.msg("\u5df2\u8bbe\u7f6e\u6df1\u8272\u6a21\u5f0f<br>\u5982\u9700\u6700\u4f73\u6548\u679c\uff0c\u5efa\u8bae\u5207\u6362\u660e\u4eae\u6a21\u5f0f")
        } else layer.close(this.INDEX)
    })
    //头部事件
    util.on({
        'header-menu': (e)=> { // 顶部左侧菜单事件
            //移除遮罩
            $body.removeClass(`lanj838-shade-show`)
            let shadeEvent = `.lanj838-shade-show .lanj838-shade`
            //移除所有遮罩事件
            $(shadeEvent).off('click')
            if ($body.hasClass(`lanj838-header-menu-show`)) {
                $body.removeClass(`lanj838-header-menu-show`)
            }else {
                let mle = `lanj838-shade-show lanj838-header-menu-show`
                $body.addClass(mle)
                $(shadeEvent).on('click', () => {
                   ($body.removeClass(mle), $(shadeEvent).off('click'))
                })
            }
        },
        'header-more': (e)=> {
            layer.open({
                type: 1,
                title: '更多',
                content: '<div style="padding: 15px;">处理右侧面板的操作</div>',
                area: ['260px', '100%'],
                offset: 'rt', // 右上角
                anim: 'slideLeft', // 从右侧抽屉滑出
                shadeClose: true,
                scrollbar: false
            });
        },
        'qq-login': (e) => {
            let mobile = isMobile();
            // 先移除旧的监听（防止重复绑定）
            // if (messageHandler) window.removeEventListener('message', messageHandler);
            // if (messageHandlerInterval) clearInterval(messageHandlerInterval);

            $.ajax({
                url:`${cache.BASE_API}login/qq`,
                data: {mobile: mobile},
                type:'GET', dataType:'json',
                success: function(data) {
                    if (data.code !== 0) return message(data.msg || '获取登录链接失败', 2);
                    // if (mobile) {
                    window.location.href = data.data.url;
                    // }else{
                    //     const width = mobile ? screen.width - 40 : 780;
                    //     const height = mobile ? screen.height - 80 : 440;
                    //     const { left, top } = calculateCenterPosition(width, height);
                    //
                    //     // 1. 先主动打开空白窗口（同步执行，避免拦截）
                    //     const qqWin = window.open(
                    //         loginUrl, // 先开空白页，避免URL异步导致拦截
                    //         '_blank',
                    //         mobile
                    //             ? null // Safari移动端需显式参数
                    //             : `width=${width},height=${height},left=${Math.round(left)},top=${Math.round(top)},toolbar=0,menubar=0,location=0`
                    //     );
                    //
                    //     if (!qqWin) {
                    //         location.href = loginUrl;
                    //     }
                    //
                    //     messageHandler = function(e) {
                    //         try {
                    //             console.log(e)
                    //             // 核心校验：仅接收同域名消息（必须保留）
                    //             if (e.origin !== window.location.origin) {
                    //                 console.log('域名不匹配，忽略消息：', e.origin);
                    //                 throw new Error('登陆失败，环境不匹配！')
                    //             }
                    //
                    //             // 校验消息格式（确保是QQ登录回调）
                    //             if (!e.data || typeof e.data !== 'object') {
                    //                 console.log('消息格式错误：', e.data);
                    //                 throw new Error('登陆失败，消息格式错误!')
                    //             }
                    //             if (e.data.timestamp && (Date.now() - e.data.timestamp) > 5 * 60 * 1000) {
                    //                 throw new Error('登录请求已过期，请重新登录!')
                    //             }
                    //
                    //             if (e.data.code !== 0) {
                    //                 throw new Error(e.data.msg || 'QQ登录失败！')
                    //             }
                    //
                    //             message('登录成功!', 1);
                    //             setTimeout(() => {
                    //                 window.location.href = '/user';
                    //             }, 1000);
                    //             try { if (qqWin && !qqWin.closed) qqWin.close(); } catch (e) {}
                    //         } catch (err) {
                    //             try { if (qqWin && !qqWin.closed) qqWin.close(); } catch (e) {}
                    //             return message(err.message || 'QQ登录失败！', 2);
                    //         } finally {
                    //             clearInterval(messageHandlerInterval);
                    //             window.removeEventListener('message', messageHandler);
                    //             console.log('清理资源完成')
                    //         }
                    //     };
                    //
                    //     // 6. 绑定消息监听（被动模式，确保生效）
                    //     window.addEventListener('message', messageHandler, {passive: true});
                    //
                    //     // 监听手动关弹窗（仅保留核心）
                    //     messageHandlerInterval = setInterval(() => {
                    //         console.log(1)
                    //         try {
                    //             if (qqWin.closed) {
                    //                 clearInterval(messageHandlerInterval);
                    //                 window.removeEventListener('message', messageHandler);
                    //             }
                    //         } catch (e) {
                    //             clearInterval(messageHandlerInterval);
                    //             window.removeEventListener('message', messageHandler);
                    //         }
                    //     }, 500);
                    // }
                }
            })
        },
        'logout': (e)=> {
            $.ajax({
                url: `/user/logout`,
                method: 'POST',
                xhrFields: { withCredentials: true },
                crossDomain: true,
                success: function() {
                    // 退出成功，跳登录页
                    const cookies = document.cookie.split(';').map(item => item.trim());
                    // 2. 解析当前域名（适配 localhost/生产域名）
                    const currentDomain = location.hostname;
                    // 兼容场景：localhost 不需要加 .，生产域名（如 xxx.com）加 . 适配子域名
                    const cookieDomain = currentDomain === 'localhost' ? currentDomain : `.${currentDomain}`;
                    // 3. 遍历所有 Cookie 逐个删除
                    cookies.forEach(cookie => {
                        // 解析 Cookie 名称（等号前的部分）
                        const [cookieName] = cookie.split('=');
                        if (!cookieName) return;

                        // 关键：删除时必须匹配 Cookie 的路径/域名（否则删不掉）
                        // 场景1：默认路径 /（绝大多数 Cookie 的路径）
                        window.removeCookie(decodeURIComponent(cookieName), '/', cookieDomain);

                        // 场景2：兼容路径为当前页面路径的 Cookie（可选，根据业务补充）
                        window.removeCookie(decodeURIComponent(cookieName), location.pathname, cookieDomain);

                        // 场景3：兼容无域名的 Cookie（兜底）
                        window.removeCookie(decodeURIComponent(cookieName), '/');
                    });
                    location.href = `/login`;
                }
            });
        }
    });

    // 自定义固定条
    util.fixbar({
        bars: [{ // 定义可显示的 bar 列表信息 -- v2.8.0 新增
            type: 'qq',
            icon: 'layui-icon-login-qq'
        }],
        on: { // 任意事件 --  v2.8.0 新增
            mouseenter: function(type){
                if (type === 'qq') {
                    layer.tips(`联系QQ: 83213956`, this, {tips: 4, fixed: true});
                }
            },
            mouseleave: function(type){
                layer.closeAll('tips');
            },
            click: function(type){
                if (type === 'qq') {
                    layer.photos({
                        photos: { // 图片层的数据源
                            "title": "联系QQ 83213956", // 相册标题
                            "data": [   // 相册包含的图片，数组格式
                                {
                                    "alt": "联系QQ 83213956",
                                    "pid": 666, // 图片id
                                    "src": "/assets/img/IMG_2310(20251219-021310).PNG", // 原图地址
                                    "thumb": "" // 缩略图地址
                                },
                            ]
                        }
                    });
                }
            }
        }
    });
})
